import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IDeleteEntity, IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerAdminService {
    customerid: string;
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uri = `${environment.apiLocation}/CompanyInfo`;
    private advisoruri = `${environment.apiLocation}/Advisor`;

    public getAdvisors(): Observable<any> {
        this.log.verbose({
            type: 'CompanyInfoService:getAdvisors',
            uri: this.advisoruri
        });
        return this.http.get<any>(this.advisoruri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'CompanyInfoService:response',
                    res
                })
            )
        );
    }

    public get(customerid, IsInternal): Observable<any> {
        this.log.verbose({
            type: 'CompanyInfoService:post',
            uri: this.uri
        });
        return this.http
            .get<any>(`${environment.apiLocation}/CompanyInfo?customerid=${customerid}&IsInternal=${IsInternal}`)
            .pipe(
                tap(res =>
                    this.log.verbose({
                        type: 'CompanyInfoService:response',
                        res
                    })
                )
            );
    }

    public put(jsonstring: string): Observable<any> {
        return this.http
            .put<any>(this.uri, {
                JsonString: jsonstring
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'CompanyInfoService:put',
                        data
                    })
                )
            );
    }
}
